import { CanMatchFn } from '@angular/router';
import { ThemeService } from '../../services/theme.service';
import { inject } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { IsTheme } from '../../interfaces/is-theme';
import { PlatformService } from '../../services/platform.service';

export const themeGuard: CanMatchFn = async () => {
	const themeService: ThemeService = inject(ThemeService);
	const platformService: PlatformService = inject(PlatformService);
	// Get theme
	const theme: IsTheme = await lastValueFrom(themeService.getTheme());
	// Check if theme is not already installed
	if (!themeService.themeInstalled && platformService.isBrowser()) {
		// Install theme
		themeService.installTheme(theme);
	}

	return true;
};
